import customAxios from "@/custom/custom-axios";
import type { TaskrptNotifySetting } from "@/types/owner/management/taskrptNotifySetting";
import type { TaskrptNotifyUrlRes } from "@/types/owner/task/taskrptNotifyUrl";

export default class TaskrptNotifyUrl {
  constructor() {}

  /* 設定状況の判定 */
  judge(
    taskrptNotifySetting: TaskrptNotifySetting,
    canOwnerShareLink: boolean,
    isShareSettingView: boolean
  ) {
    const isEnabled = taskrptNotifySetting?.enabled === 1;
    //物件タイプ、仕事タイプが設定で有効になっているか？
    const isSelected = canOwnerShareLink;

    let judgeShowShare2Modal = false;
    let judgeShowShare3Modal = false;

    if (isEnabled && !isShareSettingView) {
      //まだ設定画面を表示していない場合
      judgeShowShare3Modal = true;
    } else if (isEnabled && !isSelected) {
      //共有設定ONだけど、仕事選択されていない場合
      judgeShowShare2Modal = true;
    }

    return {
      judgeShowShare2Modal: judgeShowShare2Modal,
      judgeShowShare3Modal: judgeShowShare3Modal
    };
  }

  /* 共有URLの発行 */
  async createShareUrl(token: any, taskId: number) {
    try {
      const res = await customAxios.get(
        `${process.env.APP_API_PATH}/owner/taskrpt-notify-url/${taskId}`,
        token
      );
      return res.data as TaskrptNotifyUrlRes;
    } catch (e) {
      console.error(e);
    }
  }
}
